import map from "lodash/map";
import includes from "lodash/includes";
import React from "react";
import set from "@rill/set";
import SettingsNav from "../../../parts/settings-nav";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const {
  NOTIFICATIONS: { TOGGLE },
} = require("../../../constants");

function View(props, { locals }) {
  const { activeUser } = locals;
  const isInvitedAthlete = Boolean(activeUser.coach);
  const notifications = isInvitedAthlete
    ? ["Coach Comment", "New Program"]
    : TOGGLE;
  return (
    <div className="Main Settings-Notifications">
      <SettingsNav />

      <form
        className="Content"
        method="POST"
        action="/actions/user/update-notifications"
        data-noreset
      >
        <div className="frame">
          <div className="columns">
            {map(notifications, (toggle) => {
              const active = includes(activeUser.notifications, toggle);
              return (
                <div key={toggle} className="column" data-col="1/1">
                  <label className="checkbox-input">
                    <input
                      name="notifications[]"
                      type="checkbox"
                      value={toggle}
                      defaultChecked={active}
                    />
                    <span className="checkbox"></span>
                    <span className="text">{toggle}</span>
                  </label>
                </div>
              );
            })}

            <div className="column" data-col="1/1">
              <button className="button-input" type="submit">
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

const Notifications = (app) => {
  app.get(
    "/notifications",
    set("heading", "Notifications"),
    ({ req, res, locals }) => {
      const { query } = req;
      const modal = query.modal || {};

      locals.modal = {
        "activity-feed": <ActivityDrawer />,
      }[modal.type];
      res.body = <View />;
    }
  );
};

export default Notifications;
